module.exports = __webpack_public_path__ + "static/media/011.98f978c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/011.jpg
// module id = 484
// module chunks = 0